"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customRecorder = customRecorder;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Uses fetch to post data to given endpoint
 */
function customRecorder(_ref) {
  var token = _ref.token,
      _ref$endpoint = _ref.endpoint,
      endpoint = _ref$endpoint === void 0 ? '/_timing' : _ref$endpoint,
      _ref$credentials = _ref.credentials,
      credentials = _ref$credentials === void 0 ? 'include' : _ref$credentials,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  } : _ref$headers;
  return function (category, label, variable, time) {
    var data = {
      category: category,
      label: label,
      variable: variable,
      event_time: time
    };

    try {
      fetch(endpoint, {
        method: 'POST',
        credentials: credentials,
        headers: headers,
        body: JSON.stringify(_objectSpread({
          token: token
        }, data))
      });
    } catch (error) {
      console.error(error);
    }
  };
}